import * as React from 'react';
import l10n = require('diy/util/l10n');
import features = require('diy/util/features');
import websiteData = require('diy/util/websiteData');

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {colors} from "material-ui/styles";

interface AviaryShutdownDialogProps {
    open: boolean;
    onClose: () => void;
}

export default class AviaryShutdownDialog
    extends React.Component<AviaryShutdownDialogProps, {}> {

    render() {
        let styles = this.getStyles();
        let locale = websiteData.getLanguageCode()
            .toLowerCase().replace('_', '-');

        return (
            <Dialog
                title={l10n.getString('aviaryDialog.shutdown.title')}
                open={this.props.open}
                modal={true}
                actions={[
                    <FlatButton
                        label={l10n.getString('aviaryDialog.closeBtn')}
                        secondary={true}
                        onTouchTap={this.onClose}
                        data-test-id="asdk-shutdown-close-btn"
                    />
                ]}>
                
                <div>
                    <p style={styles.paragraph} dangerouslySetInnerHTML={{
                        __html: l10n.getString('aviaryDialog.shutdown.shutdownNotice')
                    }}>
                    </p>
                    
                    {
                        (features('cmsImagesAvailable')
                            || features('premiumImages')
                            || features('bigstock')
                            || features('123rf'))
                        ?
                        <div>
                            <p style={styles.paragraph} dangerouslySetInnerHTML={{
                                __html: l10n.getString('aviaryDialog.shutdown.imageGalleryRecommendation')
                            }}>
                            </p>
                            <p style={styles.paragraph}>
                                <img src={cc_.cdnServer + "s/img/cms/help/txtimg/" + locale + "/ac_image_image_tab.png"} alt="" />
                            </p>
                        </div>
                        :
                        ''
                    }

                    <p style={styles.lastParagraph} dangerouslySetInnerHTML={{
                       __html: l10n.getString('aviaryDialog.shutdown.help').replace(
                           "{cpContactUrl}",
                           `<a style="color:${styles.link.color}" target="_blank" href=${websiteData.getCpContactUrl()}>${l10n.getString("aviaryDialog.shutdown.contactLink")}</a>`
                       )
                    }}>
                    </p>
                </div>
            </Dialog>
        );
    }

    private onClose = () => {
        this.props.onClose();
    };

    private getStyles = () => {
        return {
            paragraph: {
                fontSize: 14,
                margin: "0 0 16px 0",
            },
            lastParagraph: {
                fontSize: 14,
                margin: "0",
            },
            link: {
                color: colors.blue500
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/aviary/AviaryShutdownDialog.tsx
 **/